export default __webpack_public_path__ + "static/media/Body_Systems.21f614ed.svg";